import { render, staticRenderFns } from "./AbkStudentNotes.vue?vue&type=template&id=69442eae&scoped=true&"
import script from "./AbkStudentNotes.vue?vue&type=script&lang=js&"
export * from "./AbkStudentNotes.vue?vue&type=script&lang=js&"
import style0 from "./AbkStudentNotes.vue?vue&type=style&index=0&id=69442eae&scoped=true&lang=scss&"
import style1 from "./AbkStudentNotes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69442eae",
  null
  
)

export default component.exports